import { storeAuthSession } from '../services/authSession';
import { tokenHotelId } from '../services/sessionHandoff';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { login } from '../services/api';

export default function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const data = await login(email, password);
      const token = data.access_token || data.token;
      storeAuthSession(token, {
        name: data.hotel_name || data.name || '',
        hotel_id: data.hotel_id || tokenHotelId(token),
      });
      navigate('/assistant', {replace:true});
    } catch (err: any) {
      const msg = typeof err === 'string' ? err : (typeof err?.message === 'string' ? err.message : 'Erreur de connexion');
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <div style={{ textAlign: 'center', marginBottom: 8 }}>
          <div className="logo" style={{ margin: '0 auto 12px', width: 56, height: 56, fontSize: 20 }}>FPT</div>
        </div>
        <h1>FPT Portail Assujetti V4</h1>
        <div className="sub">Gestion FPT &amp; Licences</div>

        <form onSubmit={handleSubmit}>
          <label htmlFor="email">Email</label>
          <input id="email" type="email" value={email} onChange={e => setEmail(e.target.value)} required placeholder="votre@email.com" />

          <label htmlFor="password">Mot de passe</label>
          <input id="password" type="password" value={password} onChange={e => setPassword(e.target.value)} required placeholder="********" />

          {error && <div className="login-error">{error}</div>}

          <button type="submit" className="btn primary login-btn" disabled={loading}>
            {loading ? 'Connexion...' : 'Se connecter'}
          </button>
        </form>

        <div style={{ textAlign: 'center', marginTop: 20, fontSize: 12, color: 'var(--muted)' }}>
          Accès réservé aux propriétaires d'établissements
        </div>
      </div>
    </div>
  );
}
